import { LogoutIcon } from '@gurupay/gp-ui-library';
import { useAuth } from '@hooks/useAuth';
import type { KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';

export const LogoutMenuItem = () => {
	const { t } = useTranslation();
	const { signOut } = useAuth();

	const handleKeyDown = ({ key }: KeyboardEvent<HTMLLIElement>) => {
		if (key === 'Enter' || key === ' ') {
			signOut();
		}
	};

	return (
		<li
			className="flex items-center text-sm-medium gap-space-8 p-space-4 cursor-pointer rounded-sm transition-all duration-200 ease-linear text-neutral-800 hover:text-neutral-950"
			onClick={signOut}
			onKeyDown={handleKeyDown}
			role="button"
			tabIndex={0}
		>
			<LogoutIcon className="w-8 min-h-8 p-space-4" />
			{t('layout.controlPanel.logout')}
		</li>
	);
};
